import { jsx as _jsx } from "react/jsx-runtime";
import * as THREE from "three";
import { matBeam } from "../material/MaterialModel";
import { useEffect, useMemo } from "react";
export const Board = ({ vertices, indices, uvs = [], position = [0, 0, 0], rotation = [0, 0, 0], name = '', material = matBeam, }) => {
    const geometry = useMemo(() => {
        if (!vertices || vertices.length < 3)
            return null;
        if (!indices || indices.length < 3)
            return null;
        const g = new THREE.BufferGeometry();
        g.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        if (uvs.length) {
            g.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
        }
        g.setIndex(indices);
        g.computeVertexNormals();
        g.computeBoundingSphere();
        g.computeTangents();
        return g;
    }, [vertices, indices, uvs]);
    useEffect(() => {
        return () => {
            geometry?.dispose();
        };
    }, [geometry]);
    if (!geometry)
        return null;
    return (_jsx("mesh", { castShadow: true, geometry: geometry, position: position, rotation: rotation, name: name, material: material }, geometry.uuid));
};
